import { SetUniqueWidgetRefreshContext } from 'App';
import Cookies from 'js-cookie';
import React, { useContext } from 'react';

const getFriendlyErrorText = (rawMessage = '') => {
  const message = String(rawMessage || '').toLowerCase();

  if (message.includes('timed out')) {
    return 'This widget request timed out. The server may be busy or temporarily unavailable.';
  }

  if (message.includes('network')) {
    return 'This widget could not reach the server. Check your connection and try refreshing.';
  }

  if (
    message.includes('invalid response') ||
    message.includes('empty or invalid response') ||
    message.includes('cannot read properties of null') ||
    message.includes('cannot read properties of undefined')
  ) {
    return 'This widget received incomplete data from the server. Try refreshing. If it keeps happening, the data service may be temporarily unavailable.';
  }

  if (!message || message === 'error fetching data') {
    return 'This widget could not load data right now. Try refreshing. If the issue continues, the server or data source may be unavailable.';
  }

  return 'This widget could not load data. Try refreshing. If it continues, contact your administrator.';
};

export const ErrorMessage = ({ message, onRetry, retryLabel, retryRoute }) => {
  const setUniqueWidgetRefresh = useContext(SetUniqueWidgetRefreshContext);
  const friendlyMessage = getFriendlyErrorText(message);
  const technicalMessage = String(message || '').trim();
  const hasOnRetry = typeof onRetry === 'function';
  const hasRouteRetry = Boolean(retryRoute);
  const canRetryWidget = hasOnRetry || hasRouteRetry;

  const handleRetryWidget = () => {
    if (hasOnRetry) {
      onRetry();
    }

    if (!hasRouteRetry) {
      if (!hasOnRetry) {
        window.location.reload();
      }
      return;
    }

    const location = `${Cookies.get('city')}-${Cookies.get('state')}`;
    const uniqueKey = `${location}-${retryRoute}`;
    const token = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

    if (typeof setUniqueWidgetRefresh === 'function') {
      setUniqueWidgetRefresh((prev) => ({
        ...(prev || {}),
        [uniqueKey]: token,
      }));
      return;
    }

    window.location.reload();
  };

  return (
    <div style={{ padding: 12 }}>
      <div
        className="rounded-2"
        style={{
          border: '1px solid rgba(220, 53, 69, 0.35)',
          background: 'rgba(220, 53, 69, 0.08)',
          color: '#ffd9de',
          padding: 12,
        }}
      >
        <div className="fw-bold mb-2" style={{ color: '#ffb8c2' }}>
          Unable to load widget data
        </div>
        <div
          className="d-grid gap-2 mt-2"
          style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))' }}
        >
          {canRetryWidget ? (
            <button
              type="button"
              className="btn btn-sm btn-outline-light"
              onClick={handleRetryWidget}
            >
              {retryLabel || 'Retry Widget'}
            </button>
          ) : null}
          <button
            type="button"
            className="btn btn-sm btn-outline-light"
            onClick={() => window.location.reload()}
          >
            Refresh Page
          </button>
        </div>

        <div style={{ lineHeight: 1.35, marginTop: 8 }}>{friendlyMessage}</div>

        {technicalMessage ? (
          <details className="mt-2" style={{ opacity: 0.85 }}>
            <summary style={{ cursor: 'pointer', fontSize: 12 }}>Technical details</summary>
            <div className="mt-1" style={{ fontSize: 12, wordBreak: 'break-word' }}>
              {technicalMessage}
            </div>
          </details>
        ) : null}
      </div>
    </div>
  );
};
